const licenseKey = "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjFlNzU1ZGJhLTUxZTktNDZkOS04YzljLWJjNmM3NTU2OWNhNCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.w9/GeAVSMwX4Iha9VVBhN+G/ScwAf0F2OoB7SuW7RsSVWR6egUfEG0U+llyU/V4uVvgd+yRgi7N4a5lquXEZCbTlbSUcFEWktP8VDRYdPA9pBdTn89BwCVGxF1+QUTKUSdoZ1g=="


export { licenseKey }